import enLocale from 'element-ui/lib/locale/lang/en'
import baseDict from './base/dict'
import order from './ims/order'
import dealer from './cmc/dealer'
import web from './cms/web'
import cmc from './cmc/cmc'
import pmc from './pmc/pmc'
import common from './common'
import ims from './ims/ims'
import base from './base/base'
import mcc from './mcc/mcc'
import mmc from './mmc/mmc'
import wechat from './wechat/wechat'
import myg from './myg/myg'

const en = {
  routeName: {
    home: 'home',
    // dictionary: 'dictionary',
    // dictionaryList: 'dictionaryList',
    // icon: 'icon',
    // builtInIcon: 'builtInIcon',
    // shuttleBox: 'shuttleBox',
    // systemManage: 'systemManage',
    // systemList: 'systemList',
    // baseInfo: 'baseInfo',
    // table: 'table',
    // orgs: 'orgs',
    // channel: 'channel',
    // jxcmk: 'jxcmk',
    // region: 'region',
    // salesman: 'salesman',
    // dearManage: 'dearManage',
    // logisticsCompany: 'logisticsCompany',
    // account: 'account',
    // dealerType: 'dealerType',
    // dealerList: 'dealerList',
    // dearAdd: 'dearAdd',
    // updateDear: 'updateDear',
    // org: 'org',
    // userList: 'userList',
    // systemSettings: 'systemSettings',
    // menuList: 'menuList',
    // urlList: 'urlList',
    // roleList: 'roleList',
    // functionList: 'functionList',
    // userEdit: 'userEdit',
    // userAdd: 'userAdd',
    // addDictionary: 'addDictionary',
    // addWarehouse: 'addWarehouse',
    // updateWarehouse: 'updateWarehouse',
    // addLogisticsCompany: 'addLogisticsCompany',
    // updateLogisticsCompany: 'updateLogisticsCompany',
    // updateDictionary: 'updateDictionary',
    // menuEdit: 'menuEdit',
    // menuAdd: 'menuAdd',
    // urlEdit: 'urlEdit',
    // roleEdit: 'roleEdit',
    // roleAdd: 'roleAdd',
    // addOrg: 'addOrg',
    // updateOrg: 'updateOrg',
    // updateRegion: 'updateRegion',
    // addRegion: 'addRegion',
    // addSalesman: 'addSalesman',
    // updateSalesman: 'updateSalesman',
    // addAccount: 'addAccount',
    // updateAccount: 'updateAccount',
    // warehouse: 'warehouse',
    // productManage: 'productManage',
    // productInfo: 'productInfo',
    // productType: 'productType',
    // productTypeAdd: 'productTypeAdd',
    // productTypeEdit: 'productTypeEdit',
    // productDescription: 'productDescription',
    // productAttribute: 'productAttribute',
    // productAttributeAdd: 'productAttributeAdd',
    // productAttributeEdit: 'productAttributeEdit',
    // productTradeMark: 'productTradeMark',
    // productUnit: 'productUnit',
    // productList: 'productList',
    // productAdd: 'productAdd',
    // productEdit: 'productEdit',
    // activity: 'activity',
    // sales: 'sales',
    // salesByMoney: 'salesByMoney',
    // presentationByMoney: 'presentationByMoney',
    // declineByMoney: 'declineByMoney',
    // discountByMoney: 'discountByMoney',
    // salesByQuantity: 'salesByQuantity',
    // presentationByQuantity: 'presentationByQuantity',
    // declineByQuantity: 'declineByQuantity',
    // discountByQuantity: 'discountByQuantity',
    // salesByOrderDir: 'salesByOrderDir',
    // salesByOrder: 'salesByOrder',
    // presentationByOrder: 'presentationByOrder',
    // declineByOrder: 'declineByOrder',
    // discountByOrder: 'discountByOrder',
    // orderManage: 'orderManage',
    // orderList: 'orderList',
    // orderDetail: 'orderDetail',
    // orderAdd: 'orderAdd',
    // orderUpdate: 'orderUpdate',
    // orderGathering: 'orderGathering',
    // orderDeliver: 'orderDeliver',
    // orderDetailList: 'orderDetailList',
    // deliverList: 'deliverList',
    // deliverVerify: 'deliverVerify',
    // deliverDetail: 'deliverDetail',
    // deliverUpdate: 'deliverUpdate',
    // stockManage: 'stockManage',
    // stockList: 'stockList',
    // saleList: 'saleList',
    // DesignerAdd: 'DesignerAdd',
    // DesignerUpdate: 'DesignerUpdate',
    // DesignerList: 'DesignerList',
    // DesignerManage: 'DesignerManage',
    // memberManage: 'memberManage',
    // memberList: 'memberList',
    // memberAdd: 'memberAdd',
    // memberEdit: 'memberEdit',
    // memberType: 'memberType',
    // memberTypeAdd: 'memberTypeAdd',
    // agentList: 'agentList',
    // agentAdd: 'agentAdd',
    // agentUpdate: 'agentUpdate',
    // caseManage: 'caseManage',
    // caseTypeList: 'caseTypeList',
    // caseList: 'caseList',
    // caseEdit: 'caseEdit',
    // caseAdd: 'caseAdd',
    // caseView: 'caseView',
    // roomManage: 'roomManage',
    // roomList: 'roomList',
    // roomEdit: 'roomEdit',
    // roomAdd: 'roomAdd',
    // roomHomepage: 'roomHomepage',
    // webManage: 'webManage',
    // webSimpleColumnAboutUs: 'webSimpleColumnAboutUs',
    // webSimpleColumnContactUs: 'webSimpleColumnContactUs',
    // webSimpleColumnDeliveryMode: 'webSimpleColumnDeliveryMode',
    // webSimpleColumnFrequentlyQuestions: 'webSimpleColumnFrequentlyQuestions',
    // webSimpleColumnLegalDeclarations: 'webSimpleColumnLegalDeclarations',
    // webSimpleColumnPrivacyClauses: 'webSimpleColumnPrivacyClauses',
    // webSimpleColumnTermsConditions: 'webSimpleColumnTermsConditions',
    // recruitJoinUs: 'recruitJoinUs',
    // vipDesignerList: 'vipDesignerList',
    // vipDesignerListAdd: 'vipDesignerListAdd',
    // vipDesignerListEdit: 'vipDesignerListEdit',
    // vipDesignerListView: 'vipDesignerListView',
    // tips: 'tips',
    // tipsList: 'tipsList',
    // tipsAdd: 'tipsAdd',
    // tipsEdit: 'tipsEdit',
    // joinUs: 'joinUs',
    // postList: 'postList',
    // postAdd: 'postAdd',
    // postEdit: 'postEdit'
  },
  rightMenu: {
    close: 'close',
    closeOther: 'closeOther',
    closeAll: 'closeAll'
  },
  role: {
    superAdmin: 'superAdmin',
    admin: 'admin',
    ordinary: 'ordinary'
  },
  userDropdownMenu: {
    basicInfor: 'basicInfor',
    changePassword: 'changePassword',
    logout: 'logout'
  },
  ...common,
  ...baseDict,
  ...order,
  ...dealer,
  ...web,
  ...cmc,
  ...pmc,
  ...ims,
  ...base,
  ...mcc,
  ...mmc,
  ...enLocale, //  合并element-ui内置翻译
  ...wechat,
  ...myg
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/lang/en/en.js